// extracted by mini-css-extract-plugin
module.exports = {"form":"EditGroupForm_form__TAB39","inputGroup":"EditGroupForm_inputGroup__L8x2-"};